import type { WalletDebitsTranslations } from "../interfaces/walletDebits";

export const walletDebitsTranslations: WalletDebitsTranslations = {
  page_title: "Descargas de billeteras",
  page_subtitle:
    "Descuenta el saldo de un cliente por un envío que Coloca hace a mano, fuera de la plataforma. El monto queda congelado hasta que registres el envío con su referencia; cada descarga pide tu código de verificación y queda en el libro contable.",
  action_refresh: "Actualizar el historial",
  action_new: "Nueva descarga",
  action_retry: "Reintentar",
  filter_organization: "Organización",
  filter_all_option: "Todas las organizaciones",
  filter_all_hint: "Se muestran las descargas de todas las organizaciones.",
  filter_org_hint: "Se muestran solo las descargas de esta organización.",

  empty_title: "Todavía no hay descargas",
  empty_description: "Las descargas que registres aparecen aquí con la referencia del envío y sus soportes.",
  col_date: "Fecha",
  col_organization: "Organización",
  col_amount: "Monto",
  col_concept: "Concepto y nota interna",
  col_external_reference: "Referencia del envío",
  col_reference: "Referencia",
  col_by: "Hecha por",
  col_attachments: "Soportes",
  card_note: "Nota interna: {{note}}",
  card_by: "Hecha por {{email}}",
  card_external_reference: "Envío: {{reference}}",
  attachments_count: "{{count}} soportes",
  attachments_count_one: "1 soporte",
  attachments_count_none: "Sin soportes",

  dialog_title: "Descargar una billetera",
  dialog_title_review: "Revisa la descarga",
  dialog_title_done: "Saldo descontado",
  dialog_title_processing: "Descontando el saldo…",
  dialog_description:
    "Descuenta el monto del saldo disponible del cliente para un envío manual. Queda congelado hasta que registres el envío con su referencia, o canceles la descarga.",
  dialog_description_review:
    "Confirma la organización, la billetera, el monto y el medio del envío antes de autorizar.",
  dialog_description_done:
    "El monto quedó congelado en la billetera del cliente. Haz el envío y registra aquí su referencia.",
  dialog_description_processing:
    "Estamos descontando el saldo y registrándolo en el libro contable; puede tardar unos segundos. No cierres esta ventana.",
  processing_to: "Envío manual",
  processing_transit_aria:
    "{{amount}} {{currency}} salen de la billetera {{currency}} de {{name}} por un envío manual.",
  action_cancel: "Cancelar",
  action_review: "Revisar descarga",
  action_back: "Volver",
  action_confirm: "Autorizar descarga",
  action_another: "Hacer otra descarga",
  action_close: "Cerrar",

  field_organization: "Organización",
  field_organization_required_hint: "Elige la organización por la que se hizo el envío.",
  field_organization_hint: "La descarga sale de una billetera de esta organización.",
  organization_unknown: "la organización",
  field_wallet: "Billetera",
  field_wallet_hint:
    "La moneda de la billetera es la moneda de la descarga. Solo se puede descargar el saldo disponible.",
  field_wallet_placeholder: "Elige una billetera",
  field_wallet_none: "Esta organización no tiene billeteras activadas, así que no hay saldo que descargar.",
  field_wallet_option: "{{currency}} · disponible {{balance}}",
  field_wallet_option_empty: "{{currency}} · sin saldo disponible",
  field_wallet_option_inactive: "{{currency}} · {{status}}",
  wallet_frozen: "congelada",
  wallet_closed: "cerrada",
  field_amount: "Monto",
  field_amount_hint: "En {{currency}}. Disponible: {{available}}.",
  field_corridor: "Medio del envío",
  corridor_other: "Otro medio",
  corridor_other_hint: "Sin comisión: se envía el monto completo.",
  send_preview_send: "envía",
  send_preview_fees: "Comisión {{commission}} · impuestos {{taxes}}",
  send_preview_hint:
    "El cliente paga la comisión e impuestos de un envío normal por ese riel, con las tarifas de su organización. La descarga resta el monto completo y lo enviado es el resto.",
  send_preview_needs_amount: "Escribe el monto para ver cuánto enviar por cada riel.",
  send_preview_below_fees: "las comisiones superan el monto",
  send_preview_no_fee_configured: "sin tarifas configuradas",
  send_preview_no_corridors: "No hay rieles de envío configurados para {{currency}}.",
  send_preview_failed: "No se pudo calcular cuánto enviar: {{message}}",
  validation_corridor: "Elige por dónde se hizo el envío.",
  validation_corridor_unpriced: "Espera a que se calcule la comisión de ese riel, o elige otro medio.",
  review_corridor: "Medio del envío",
  review_commission: "Comisión",
  review_taxes: "Impuestos",
  review_send_by_hand: "Enviado manualmente",
  done_fees: "Lo que pagó el cliente",
  field_external_reference: "Referencia del envío",
  field_external_reference_placeholder: "Ej.: TRF-20261027-004512",
  field_concept: "Concepto",
  field_concept_hint: "El cliente lo ve en su extracto.",
  concept_default: "Envío manual",
  field_note: "Nota interna",
  field_note_hint: "Solo la ve el equipo de Coloca: por qué el envío se hizo a mano y quién lo pidió.",
  field_note_placeholder: "Ej.: rail caído, solicitado por soporte #519",
  field_attachments: "Soportes del envío",

  validation_wallet: "Elige la billetera que se debita.",
  validation_amount: "Escribe un monto mayor que cero.",
  validation_amount_precision: "{{currency}} admite como máximo {{digits}} decimales.",
  validation_amount_exceeds: "Supera el saldo disponible ({{available}}).",
  validation_concept: "Escribe el concepto que verá el cliente.",
  validation_note: "Escribe una nota interna para el registro.",

  review_organization: "Organización",
  review_wallet: "Billetera",
  review_wallet_value: "Billetera {{currency}}",
  review_balance_before: "Saldo disponible ahora",
  review_amount: "Débito por el envío",
  review_balance_after: "Saldo después de la descarga",
  review_concept: "Concepto (lo ve el cliente)",
  review_note: "Nota interna",
  review_client_sees:
    "El cliente la verá en su extracto como un débito de Coloca Payments con el concepto. No recibe correo; a ti y a contabilidad les llega el aviso cuando registres el envío.",
  review_checkbox: "Revisé la organización, la billetera, el monto y el medio del envío",

  two_factor_required:
    "Para descargar billeteras necesitas la verificación en dos pasos activa. Actívala en Configuración y vuelve.",
  two_factor_description: "Vas a descargar {{amount}} {{currency}} de la billetera de {{name}}.",

  unresolved_title: "Una descarga quedó sin confirmar",
  unresolved_text:
    "Se autorizó una descarga de {{amount}} ({{reference}}) a esta organización y no llegó la respuesta, así que no sabemos si se descontó. Compruébala antes de hacer otra.",
  unresolved_text_retry:
    "No llegó la respuesta, así que no sabemos si esta descarga se debitó. Compruébala, o autorízala de nuevo: si ya se había hecho, no se debita dos veces.",
  unresolved_action: "Comprobar la descarga",
  unresolved_pending: "Todavía se está procesando. Vuelve a comprobarla en unos segundos.",
  unresolved_unknown: "No pudimos comprobarla. Vuelve a intentarlo en un momento.",
  unresolved_not_placed: "La descarga que quedó sin confirmar no se debitó. Ya puedes hacer la descarga.",
  debit_busy:
    "Otra pestaña está enviando una descarga a esta organización. Espera a que termine y vuelve a autorizar; no se envió nada.",
  unresolved_blocked: "Hay una descarga a esta organización sin confirmar. Compruébala antes de hacer otra.",

  done_recovered:
    "La descarga que quedó sin confirmar sí se debitó. Este es su registro; comprobarla no debitó nada de nuevo.",
  done_replayed:
    "Esta descarga ya se había hecho con estos mismos datos. No se debitó de nuevo ni se enviaron correos.",
  done_receipt_label: "Descarga",
  done_amount: "Monto descontado",
  done_organization: "Organización",
  done_wallet: "Billetera",
  done_concept: "Concepto",
  done_external_reference: "Referencia del envío",
  done_emails_label: "Avisos enviados",
  email_pending: "Estamos enviando el aviso {{who}}.",
  email_sent: "Enviamos el aviso {{who}}.",
  email_failed: "No pudimos enviar el aviso {{who}}. La descarga quedó registrada igual.",
  email_to_operator: "a tu correo",
  email_to_accounting: "al correo de contabilidad",

  attachments_title: "Soportes del envío",
  attachments_empty: "Esta descarga todavía no tiene soportes.",
  attachments_uploading: "Subiendo los soportes…",
  attachments_uploaded: "Soportes subidos.",
  attachments_failed:
    "No pudimos subir los soportes: {{message}} La descarga quedó registrada; vuelve a intentarlo.",
  attachments_retry: "Subir de nuevo",
  attachments_upload: "Subir soportes",
  attachments_open: "Abrir {{name}}",
  attachments_unavailable: "Enlace no disponible",
  attachments_full: "Esta descarga ya tiene el máximo de {{max}} soportes.",
  attachments_meta: "{{size}} · {{email}}",
  col_status: "Estado",
  status_reserved: "Pendiente de envío",
  status_reserved_stale: "Envío pendiente hace más de un día",
  status_sent: "Enviada",
  status_cancelled: "Cancelada",
  member_status: "Estado",
  member_status_reserved: "En proceso",
  member_status_sent: "Completado",
  member_status_cancelled: "Cancelado: el saldo volvió a tu billetera",
  review_held:
    "El monto queda congelado en la billetera del cliente hasta que registres el envío o canceles la descarga. Una vez enviada ya no se puede cancelar: se corrige con una carga.",
  review_to_send_by_hand: "Por enviar manualmente",
  done_sent_by: "Envío registrado por",
  pending_heading: "Envía {{amount}} y registra el envío",
  pending_text_rail:
    "Hazlo por {{rail}} desde el banco o el proveedor. El monto ya está congelado en la billetera del cliente: no lo puede usar mientras tanto.",
  pending_text_other:
    "Hazlo por el medio acordado. El monto ya está congelado en la billetera del cliente: no lo puede usar mientras tanto.",
  pending_section_title: "Pendientes de envío",
  pending_section_hint:
    "Saldo congelado que todavía no tiene el envío registrado, el más antiguo primero. Ábrela para registrar el envío o cancelarla.",
  pending_section_failed: "No pudimos cargar las pendientes: {{message}}",
  send_title: "Registrar el envío",
  send_hint:
    "Cuando hayas hecho el envío, escribe su referencia en el banco o el proveedor. El comprobante puedes adjuntarlo ahora o después.",
  send_action: "Registrar envío",
  send_upload_failed:
    "El envío quedó registrado, pero los soportes no se subieron: {{message}} Puedes subirlos abajo.",
  cancel_open: "No se hizo el envío: cancelar la descarga",
  cancel_title: "Cancelar la descarga",
  cancel_hint:
    "Los {{amount}} vuelven al saldo disponible del cliente y el débito se reversa en su extracto.",
  cancel_reason: "Motivo",
  cancel_reason_placeholder: "Ej.: el banco rechazó la transferencia",
  cancel_confirm: "Cancelar descarga",
  cancel_back: "Volver",
  cancel_two_factor: "Vas a cancelar la descarga {{reference}} y devolver el saldo al cliente.",
  cancelled_text: "Cancelada por {{who}} el {{when}}. Motivo: {{reason}}. El saldo volvió al cliente.",
  reference_edit: "Editar",
  reference_edit_hint: "La referencia anterior queda en el historial.",
  reference_save: "Guardar referencia",
  attachments_remove: "Quitar",
  attachments_remove_aria: "Quitar {{name}}",
  attachments_remove_confirm: "¿Quitar este soporte? Queda guardado y en el historial.",
  attachments_remove_yes: "Sí, quitar",
  timeline_title: "Historial",
  timeline_failed: "No pudimos cargar el historial: {{message}}",
  timeline_reserved: "Saldo descontado",
  timeline_sent: "Envío registrado",
  timeline_cancelled: "Descarga cancelada",
  timeline_reference_changed: "Referencia corregida",
  timeline_attachments_added: "Soportes agregados",
  timeline_attachment_removed: "Soporte quitado",
  timeline_reference_detail: "{{from}} → {{to}}",
  timeline_two_factor: "con 2FA",
};
